import { Fragment, jsx as reactJsx, jsxs as reactJsxs } from 'react/jsx-runtime';
import { withDefaultProps } from './defaultProps.js';

export { Fragment };

export function jsx(type, props, key) {
    return reactJsx(type, withDefaultProps(type, props), key);
}

export function jsxs(type, props, key) {
    return reactJsxs(type, withDefaultProps(type, props), key);
}
